export default __webpack_public_path__ + "static/media/img3.ee3cae0d.png";